import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ruhul from "../../assets/imgs/instructor-img-10.png";
import styles from "./Instructor.module.css";
import Image from "next/image";
import FamilyDevelopment from "../FamilyDevelopment/FamilyDevelopment";

function Instructor(props) {
  const { orgData } = props;

  return (
    <>
      <div className="Section">
        <Container maxWidth="lg">
          <div className={styles.Instructor}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <h1>Classes taught by well-renowned scholars</h1>
                <p>
                  MUNA Academy teachers are leading Imam & scholars, and{" "}
                  <br></br>
                  pleased to share their knowledge, wisdom, and skills with you.
                </p>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <a className={styles.InstructorCard}>
                  <div className={styles.InstructorCardImg}>
                    <img src="https://cdn.mytakbir.com/static-assets/images/new-instructor-img/takbir-muna-academy-khaleel-ur-rehman-chishti.png" />
                  </div>
                  <div className={styles.InstructorCardInfo}>
                    <h2>Prof. Khaleel-ur-Rahman Chishti</h2>
                    <h3>Islamic Scholar & Author</h3>
                  </div>
                </a>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <a className={styles.InstructorCard}>
                  <div className={styles.InstructorCardImg}>
                    <img src="https://cdn.mytakbir.com/static-assets/images/takbir-muna-academy-imam-dalouer-hossain.png" />
                  </div>
                  <div className={styles.InstructorCardInfo}>
                    <h2>
                      Imam Dalouer <br /> Hossain
                    </h2>
                    <h3>National President, MUNA</h3>
                  </div>
                </a>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <a className={styles.InstructorCard}>
                  <div className={styles.InstructorCardImg}>
                    {/* <img src="https://cdn.mytakbir.com/static-assets/images/new-instructor-img/takbir-muna-academy-dr-ruhul-amin-ny.png" /> */}
                    <Image src={ruhul} />
                  </div>
                  <div className={styles.InstructorCardInfo}>
                    <h2>
                      Prof. Dr. Muhammad <br /> Ruhul Amin
                    </h2>
                    <h3>Director, MUNA Academy</h3>
                  </div>
                </a>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <a className={styles.InstructorCard}>
                  <div className={styles.InstructorCardImg}>
                    <img src="https://cdn.mytakbir.com/static-assets/images/takbir-muna-academy-dr-osmani-pic.png" />
                  </div>
                  <div className={styles.InstructorCardInfo}>
                    <h2>
                      Dr. Noor Mohammad <br /> Osmani
                    </h2>
                    <h3>
                      Associate Professor <br />
                      International Islamic University Malaysia
                    </h3>
                  </div>
                </a>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <a className={styles.InstructorCard}>
                  <div className={styles.InstructorCardImg}>
                    <img src="https://cdn.mytakbir.com/static-assets/images/takbir-muna-academy-abu-samihah-sirajul-islam-ny.png" />
                  </div>
                  <div className={styles.InstructorCardInfo}>
                    <h2>
                      Ustadh AbuSamiha <br /> Sirajul-Islam
                    </h2>
                    <h3>
                      Teacher
                      <br /> Quran Academy For Young Scholars (QAFYS)
                    </h3>
                  </div>
                </a>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <a className={styles.InstructorCard}>
                  <div className={styles.InstructorCardImg}>
                    <img src="https://cdn.mytakbir.com/static-assets/images/takbir-abu-talib-mohammad-monawer.png" />
                  </div>
                  <div className={styles.InstructorCardInfo}>
                    <h2>Dr. Abu Talib Mohammad Monawer</h2>
                    <h3>
                      Adjunct Faculty, Manarat International University, Dhaka
                      {/* Islamic Scholar & Researcher <br />
                    Universiti Malaya, Kuala Lumpur */}
                    </h3>
                  </div>
                </a>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
}

export default Instructor;
